import React from "react";
import DropDown from "../formComponents/dropDown";
import { customFunction } from "../../Helper";
import CustomDropDown from "../formComponents/CustomDropDown";

export const Country=({direction,clearable,className="",dataSource,errors,isFooterLabel,disabled,id,boxNumber,label,value,onBlur,onChange})=>{
  const onChangeHandler = (e, data) => {
    onChange(data.value)
  }
    return(
      <DropDown  boxNumber={boxNumber}
      id={id}
      label={label}
      clearable={clearable}
      className={`field-bg dropdown100 addInfoCode ${className}`}
      disabled={disabled}
      search={customFunction}
      direction={direction}
      data={dataSource || []}
     labelClass="text-none"
     errors={errors}
     isLabel={true}
     isFooterLabel={isFooterLabel}
     name="countryCode"
     value={value}
     displayType={false}
      onChange={(value) => {
      onChange && onChange(value)

      }}
      onBlur={onBlur}
    />
    )
}
Country.defaulProps={
  direction:"center",
  clearable:false
}